import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-catenary-toggle-button',
  templateUrl: './catenary-toggle-button.component.html',
  styleUrls: ['./catenary-toggle-button.component.scss'],
})
export class CatenaryToggleButtonComponent implements OnInit {
  caption: string;

  @Input() buttonType: string;
  @Input() activated = true;
  @Input() disabled = false;

  @Output() clicked: EventEmitter<void> = new EventEmitter<void>();

  constructor() {
    this.caption = 'TOGGLE';
    this.buttonType = 'floater';
  }

  ngOnInit(): void {
    this.setCaption();
  }

  setCaption(): void {
    const caption = {
      floater: 'BUOYANCY',
      stiffener: 'STIFFENER',
      strake: 'STRAKE',
      desktop: 'CATENARY SEGMENTS',
      stressjoint: 'STRESSJOINT',
      flexjoint: 'FLEXJOINT',
      default: 'TOGGLE',
    };
    this.caption = caption[this.buttonType] ?? caption.default;
  }

  toggle(): void {
    this.activated = !this.activated;
    this.clicked.emit();
  }
}
